module.exports = __webpack_public_path__ + "img/1.a7842ce3.jpg";